import { CreateButton } from "@/components/admin/create-button";
import { useTranslate } from "ra-core";

import useAppBarHeight from "../misc/useAppBarHeight";

export const ContactEmpty = () => {
  const translate = useTranslate();
  const appbarHeight = useAppBarHeight();
  return (
    <div
      className="flex flex-col justify-center items-center gap-3"
      style={{
        height: `calc(100dvh - ${appbarHeight}px)`,
      }}
    >
      <img src="./img/empty.svg" alt={translate("atomic.contacts.noContactsFound")} />
      <div className="flex flex-col gap-0 items-center">
        <h6 className="text-lg font-bold">{translate("atomic.contacts.noContactsFound")}</h6>
        <p className="text-sm text-muted-foreground text-center mb-4">
          {translate("atomic.contacts.emptyList")}
        </p>
      </div>
      <div className="flex flex-row gap-2">
        <CreateButton label={translate("atomic.contacts.newContact")} />
      </div>
    </div>
  );
};
